import React from "react";
import Notification from "@/components/Notification/Notification";
import { Outlet } from "react-router-dom";
import { UserDataProvider } from "@/contexts/UserContext";
import { NotificationsDataProvider } from "@/contexts/NotificationsContext";
import { ChatDataProvider } from "@/contexts/ChatContext";

export default function Wrapper() {
  return (
    <UserDataProvider>
      <NotificationsDataProvider>
        <ChatDataProvider>
          <Notification />
          <Outlet />
        </ChatDataProvider>
      </NotificationsDataProvider>
    </UserDataProvider>
  );
}
